@if (fieldDef.meta?.value_hidden) {
  <mat-form-field class="flex-auto w-full gt-xs:pr-3 contact-wrapper">
    <mat-label>{{ fieldDef.label }}</mat-label>
    <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
  </mat-form-field>
} @else {
  <ng-container
    *ngIf="
      customObjType === 'Company' ||
      customObjType === 'Contact' ||
      customObjType === 'Property' ||
      customObjType === 'Project' ||
      customObjType === 'User' ||
      isCustomObjectLookup
    "
  >
    <div class="flex-auto w-full gt-xs:pr-3 min-w-0">
      <label class="block text-sm font-medium mb-1">
        <span class="text-ellipsis overflow-hidden pointer-events-auto" [matTooltip]="fieldDef.label" tooltipIfEllipsis>
          {{ fieldDef.label }}
        </span>
      </label>
      <div
        class="ts-select-wrapper"
        [ngClass]="{ 'disabled': isDisabled }"
        TsFieldStyling
        [fieldBackgroundColor]="fieldStyling().color"
        [fieldBold]="fieldStyling().is_bold"
        [maxElementColoringRecursionDepth]="5"
        style="max-width: 100%"
      >
        <ts-select
          [ngModel]="tsSelectValue"
          [tooltip]="value"
          [listItemTooltip]="true"
          (ngModelChange)="onTsSelectChange($event)"
          [name]="fieldDef.name"
          [items]="searchOptions"
          [itemKey]="itemKey"
          [itemLabel]="itemLabel"
          [multi]="isMultipleField"
          [disabled]="isDisabled"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Type to search...',
            searchPlaceholder: 'Search...',
          }"
          (searchChange)="onSearchChange($event)"
        >
        </ts-select>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="customObjType === 'FileResource'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" matInput />
      <div [matTooltip]="showTip" class="flex flex-row justify-between items-center w-full" [ngClass]="{ 'disabled': isDisabled }" *ngIf="!uploadingFile">
        <span class="file-resource-label" *ngIf="!value"> Upload a file... </span>
        <span class="w-40 underline truncate cursor-pointer" (click)="viewFile(fileResource)" *ngIf="!isMultipleField">
          {{ value | readableField: model : fieldDef : [] }}
        </span>

        <ng-container
          *ngIf="isMultipleField"
          [ngTemplateOutlet]="multipleRecordList"
          [ngTemplateOutletContext]="{ value: value }"
        ></ng-container>

        <ng-container *ngIf="(!value || isMultipleField) && !isDisabled">
          <button
            [class.always-visible]="isMultipleField"
            class="mr-2 add-file-btn"
            type="button"
            mat-icon-button
            (click)="addFileInput.click()"
            [disabled]="isDisabled"
          >
            <mat-icon [svgIcon]="'add_box'"></mat-icon>
            <input
              style="display: none"
              type="file"
              (change)="onFileChanged($event)"
              #addFileInput
              [accept]="acceptAttribute"
            />
          </button>
        </ng-container>

        <ng-container *ngIf="(!isMultipleField && !!value) && !isDisabled">
          <button matSuffix mat-icon-button [matMenuTriggerFor]="menu" matTooltip="More actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="value && !isDisabled" (click)="downloadFile(fileResource)">
              <mat-icon [svgIcon]="'get_app'"></mat-icon>
              <span>Download</span>
            </button>

            <button mat-menu-item (click)="editFileInput.click()">
              <mat-icon>edit</mat-icon>
              <input
                style="display: none"
                type="file"
                (change)="onFileChanged($event)"
                #editFileInput
                [accept]="acceptAttribute"
              />
              <span>Edit</span>
            </button>

            <button mat-menu-item (click)="removeModelField($event)" *ngIf="value && !isDisabled">
              <mat-icon>cancel</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </ng-container>
      </div>
      <mat-progress-bar *ngIf="uploadingFile" mode="indeterminate"></mat-progress-bar>
      <mat-hint class="pb-1" *ngIf="hasImageRecordFormat"
        >Supported formats: {{ imageRecordFormats.join(', ') }}</mat-hint
      >
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="customObjType === 'Engagement'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        @if (value) {
          {{ value?.engagement_type }} on {{ value?.event_date | date: 'MMM dd, y' }}
        }
      </div>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="hasNoRecordType()">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        <task-status [task]="value" [taskStatuses]="workflowStates" (onUpdate)="updateTask(value)"></task-status>
        <a (click)="goToRecord()">
          <div class="flex flex-col">
            <span class="font-semibold leading-none">{{ value.title }}</span>
            <span class="mt-1 text-sm leading-none text-secondary">
              <span *ngIf="value.due_date">{{ value.due_date | date: 'LLL dd, y' }}</span>
              <span *ngIf="value.assigned_user_name">• {{ value.assigned_user_name }}</span>
            </span>
          </div>
        </a>
      </div>
    </mat-form-field>
  </ng-container>

  <!-- RECORD MULTIPLE INPUT -->
  <ng-template let-value="value" #multipleRecordList>
    <mat-chip-list #chipList class="my-3">
      <mat-chip
        *ngFor="let item of value"
        [removable]="!isDisabled"
        (removed)="!isDisabled && removeItem(item)"
        (click)="!isDisabled && goToRecord(item)"
      >
        {{ item.split('|')[1] }}
        @if (!isDisabled) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip>
    </mat-chip-list>
  </ng-template>
}
